// The app icon + app name
import React from 'react';

import styles from '../styles/apptitle.module.css';
import { APP_NAME } from '../constants';
import assets from '../assets';

const AppTitle = () => (
	<div className={styles.container}>
		<img
			className={styles.appIcon}
			alt="App icon"
			src={assets.appIcon}
		/>
		<div className={styles.appName}>
			{APP_NAME}
		</div>
	</div>
);

export default AppTitle;